import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../modules/dashboard/views/DashboardView.vue'
import LoginView from '../modules/auth/views/LoginView.vue'
import PerfilView from '../modules/auth/views/PerfilView.vue'
const RecuperarPasswordView = () => import('../modules/auth/views/RecuperarPasswordView.vue')
const NuevaPasswordView = () => import('../modules/auth/views/NuevaPasswordView.vue')
const ParametroListView = () => import('../modules/parametros/ParametroList.vue')
const TestMailView = () => import('../modules/parametros/TestMailView.vue')
const UsuarioListView = () => import('../modules/usuarios/UsuarioList.vue')
const MenusView = () => import('../modules/menus/views/MenusView.vue')
const ModulosView = () => import('../modules/modulos/views/ModulosView.vue')
const GrupousView = () => import('../modules/grupos/GrupousView.vue')
const LogsView = () => import('../modules/logs/LogsView.vue')
import DebugAccessView from '../views/DebugAccessView.vue'
import AdminDashboardView from '../views/AdminDashboardView.vue'

// Finanzas — Presupuesto
const PresupuestoList = () => import('../modules/finanzas/presupuesto/views/PresupuestoList.vue')
const PresupuestoForm = () => import('../modules/finanzas/presupuesto/views/PresupuestoForm.vue')

// Importaciones para catálogos (MODO1)
import { CatAlmacenView, CatBancoView, CatMonedaView, CatCecoView, CatDepartamentoView, CatMaterialView, CatSocioNegocioView, CatTurnoView, CatPuestoView, CatEmpleadoView, CatEmpleadoArchivoTipoView, CatEmpleadoIdentificacionTipoView, CatCuentaContableView, CatDimensionView, CatErpView, CatEstadoView, CatGrupoMaterialView, CatGrupoSocioNegocioView, CatDiasCreditoView, CatImpuestoView, CatMapeoErpView, CatMaterialAlmacenView, CatObjetoView, CatProyectoView, CatProyectoEstatusView, CatProyectoContactoRolView, CatProyectoArchivoTipoView, CatSerieView, CatUMedidaView, CatGrupoEmpleadoView, CatMotivosRechazoView, CatEmpresaView, CatSucursalView, CatCondicionPagoView, CatRetencionView, CatPaisView, CatPersonaContactoView, SatCatalogosView, SatFormaPagoView, SatMetodoPagoView, SatCatalogoGenericoView } from '../modules/catalogos/index.js'

// Importaciones para el módulo de documentos comerciales (genérico)
const DocList = () => import('../modules/compras/documentos/views/DocList.vue')
const DocForm = () => import('../modules/compras/documentos/views/DocForm.vue')
const ReqFormCompact = () => import('../modules/compras/req/views/ReqFormCompact.vue')

// REQ
const ReqList  = () => import('../modules/compras/req/views/ReqList.vue')

// SOC
const SocList  = () => import('../modules/compras/soc/views/SocList.vue')
const SocForm  = () => import('../modules/compras/soc/views/SocForm.vue')

// Importaciones para el módulo de configuración de compras (ex usuarios)
const UsuarioList = () => import('../modules/compras/configuracion/views/UsuarioList.vue')
const UsuarioForm = () => import('../modules/compras/configuracion/views/UsuarioForm.vue')

// Importaciones para el módulo de autorización (ex matriz-autorizacion)
const AutorizacionForm = () => import('../modules/compras/autorizacion/views/MatrizAutorizacionForm.vue')

// Importaciones para el módulo de reporte general
const ReporteGeneralList = () => import('../modules/compras/reporte-general/views/ReporteGeneralList.vue')

// Importaciones para el módulo de trazabilidad de compras (ERP externo vía middleware)
const ErpTrazabilidadComprasList = () => import('../modules/compras/erp-trazabilidad/views/ErpTrazabilidadComprasList.vue')
const SeguimientoFirmesList = () => import('../modules/compras/seguimiento-firmes/views/SeguimientoFirmesList.vue')

// Importaciones para el módulo de listas de precios (movido desde modulito)
const ListaPreciosView = () => import('../modules/compras/listaprecios/views/ListaPreciosView.vue')

// Gestion de proyectos
const ProyectoGestionList = () => import('../modules/proyectos/views/ProyectoGestionList.vue')
const CfdiImportacionView = () => import('../modules/cfdi-importacion/views/CfdiImportacionView.vue')
const SatFielView = () => import('../modules/sat-fiel/views/SatFielView.vue')
const SatDescargaMasivaView = () => import('../modules/sat-descarga-masiva/views/SatDescargaMasivaView.vue')
const AsistenciaView = () => import('../modules/asistencia/AsistenciaView.vue')
const MisPendientes = () => import('../modules/pendientes/views/MisPendientes.vue')

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  // Dashboard administrativo (Grupo=2) - sin publicar en el menu, accesible directamente por URL
  {
    path: '/_admin',
    name: 'admin-dashboard',
    component: AdminDashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/recuperar-password',
    name: 'recuperar-password',
    component: RecuperarPasswordView
  },
  {
    path: '/recuperar-password/nueva',
    name: 'nueva-password',
    component: NuevaPasswordView
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: PerfilView,
    meta: { requiresAuth: true }
  },
  {
    path: '/pendientes',
    name: 'mis-pendientes',
    component: MisPendientes,
    meta: { requiresAuth: true, title: 'Mis pendientes' }
  },
  { path: '/config/menus', name: 'menus', component: MenusView, meta: { requiresAuth: true } },
  { path: '/menus', redirect: '/config/menus' },
  {
    path: '/config/parametros',
    name: 'parametros',
    component: ParametroListView,
    meta: { requiresAuth: true }
  },
  {
    path: '/config/testmail',
    name: 'testmail',
    component: TestMailView,
    meta: { requiresAuth: true, title: 'Test Email', breadcrumb: 'Config > Test Email' }
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: UsuarioListView,
    meta: { requiresAuth: true }
  },
  { path: '/config/grupou', name: 'grupous', component: GrupousView, meta: { requiresAuth: true } },
  { path: '/grupous', redirect: '/config/grupou' },
  { path: '/config/modulos', name: 'modulos', component: ModulosView, meta: { requiresAuth: true } },
  { path: '/config/logs', name: 'config-logs', component: LogsView, meta: { requiresAuth: true, title: 'Logs', breadcrumb: 'Config > Logs' } },
  // ==================================================
  // Módulo de Documentos Comerciales - Compras
  // Rutas genéricas: el tipodocumento define el comportamiento
  // ==================================================

  // Órdenes de Compra
  { path: '/compras/oc', name: 'oc-list', component: DocList, props: { tipodocumento: 'OC' }, meta: { requiresAuth: true, title: 'Órdenes de Compra', module: 'compras', permission: 'read' } },
  { path: '/compras/oc/nuevo', name: 'oc-nuevo', component: DocForm, props: { tipodocumento: 'OC', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Orden de Compra', module: 'compras', permission: 'create' } },
  { path: '/compras/oc/:id(\\d+)/:token?', name: 'oc-ver', component: DocForm, props: r => ({ tipodocumento: 'OC', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Orden de Compra', module: 'compras', permission: 'read' } },
  { path: '/compras/oc/:id(\\d+)/:token?/editar', name: 'oc-editar', component: DocForm, props: r => ({ tipodocumento: 'OC', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Orden de Compra', module: 'compras', permission: 'update' } },
  { path: '/compras/oc/:pathMatch(.*)*', redirect: { name: 'oc-list' } },

  // REQ
  { path: '/compras/req',                              name: 'req-list',   component: ReqList,       meta: { requiresAuth: true, title: 'Requisiciones', module: 'compras', permission: 'read' } },
  { path: '/compras/req/nuevo',                        name: 'req-nuevo',  component: DocForm, props: { tipodocumento: 'REQ', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva REQ', module: 'compras', permission: 'create' } },
  { path: '/compras/req/nueva',                        name: 'req-nueva',  component: ReqFormCompact, props: { modo: 'nueva' }, meta: { requiresAuth: true, title: 'Nueva REQ', module: 'compras', permission: 'create' } },
  { path: '/compras/req/:id(\\d+)/:token?',            name: 'req-ver',    component: DocForm, props: r => ({ tipodocumento: 'REQ', modo: 'ver',    id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver REQ',    module: 'compras', permission: 'read' } },
  { path: '/compras/req/:id(\\d+)/:token?/editar',     name: 'req-editar', component: DocForm, props: r => ({ tipodocumento: 'REQ', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar REQ', module: 'compras', permission: 'update' } },
  { path: '/compras/req/nueva/:id(\\d+)/:token?',      name: 'req-nueva-ver', component: ReqFormCompact, props: r => ({ modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver REQ', module: 'compras', permission: 'read' } },
  { path: '/compras/req/nueva/:id(\\d+)/:token?/editar', name: 'req-nueva-editar', component: ReqFormCompact, props: r => ({ modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar REQ', module: 'compras', permission: 'update' } },
  { path: '/compras/req/:pathMatch(.*)*', redirect: { name: 'req-list' } },

  // SOC
  { path: '/compras/soc', name: 'soc-list', component: SocList, meta: { requiresAuth: true, title: 'SOC', module: 'compras', permission: 'read' } },
  { path: '/compras/soc/nuevo', name: 'soc-nuevo', component: DocForm, props: { tipodocumento: 'SOC', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva SOC', module: 'compras', permission: 'create' } },
  { path: '/compras/soc/nueva',  name: 'soc-nueva',  component: SocForm, props: { modo: 'nueva' }, meta: { requiresAuth: true, title: 'Nueva SOC', module: 'compras', permission: 'create' } },
  { path: '/compras/soc/:id(\\d+)/:token?', name: 'soc-ver', component: DocForm, props: r => ({ tipodocumento: 'SOC', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver SOC', module: 'compras', permission: 'read' } },
  { path: '/compras/soc/:id(\\d+)/:token?/editar', name: 'soc-editar', component: DocForm, props: r => ({ tipodocumento: 'SOC', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar SOC', module: 'compras', permission: 'update' } },
  { path: '/compras/soc/nueva/:id(\\d+)/:token?', name: 'soc-nueva-ver', component: SocForm, props: r => ({ modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver SOC', module: 'compras', permission: 'read' } },
  { path: '/compras/soc/nueva/:id(\\d+)/:token?/editar', name: 'soc-nueva-editar', component: SocForm, props: r => ({ modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar SOC', module: 'compras', permission: 'update' } },
  { path: '/compras/soc/:pathMatch(.*)*', redirect: { name: 'soc-list' } },

  // Solicitud de Cotización
  { path: '/compras/scot', name: 'scot-list', component: DocList, props: { tipodocumento: 'SCOT' }, meta: { requiresAuth: true, title: 'Solicitudes de Cotización', module: 'compras', permission: 'read' } },
  { path: '/compras/scot/nuevo', name: 'scot-nuevo', component: DocForm, props: { tipodocumento: 'SCOT', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Solicitud de Cotización', module: 'compras', permission: 'create' } },
  { path: '/compras/scot/:id(\\d+)/:token?', name: 'scot-ver', component: DocForm, props: r => ({ tipodocumento: 'SCOT', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Solicitud de Cotización', module: 'compras', permission: 'read' } },
  { path: '/compras/scot/:id(\\d+)/:token?/editar', name: 'scot-editar', component: DocForm, props: r => ({ tipodocumento: 'SCOT', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Solicitud de Cotización', module: 'compras', permission: 'update' } },
  { path: '/compras/scot/:pathMatch(.*)*', redirect: { name: 'scot-list' } },

  // EM visible (internamente usa ENTI)
  { path: '/compras/em', name: 'em-list', component: DocList, props: { tipodocumento: 'ENTM' }, meta: { requiresAuth: true, title: 'EM', module: 'compras', permission: 'read' } },
  { path: '/compras/em/nuevo', name: 'em-nuevo', component: DocForm, props: { tipodocumento: 'ENTM', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva EM', module: 'compras', permission: 'create' } },
  { path: '/compras/em/:id(\\d+)/:token?', name: 'em-ver', component: DocForm, props: r => ({ tipodocumento: 'ENTM', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver EM', module: 'compras', permission: 'read' } },
  { path: '/compras/em/:id(\\d+)/:token?/editar', name: 'em-editar', component: DocForm, props: r => ({ tipodocumento: 'ENTM', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar EM', module: 'compras', permission: 'update' } },
  { path: '/compras/enti', redirect: { name: 'em-list' } },
  { path: '/compras/enti/nuevo', redirect: { name: 'em-nuevo' } },
  { path: '/compras/enti/:id(\\d+)/:token?', redirect: to => ({ name: 'em-ver', params: to.params }) },
  { path: '/compras/enti/:id(\\d+)/:token?/editar', redirect: to => ({ name: 'em-editar', params: to.params }) },
  { path: '/compras/em/:pathMatch(.*)*', redirect: { name: 'em-list' } },

  // Cotización de Proveedor (recibida)
  { path: '/compras/cotcom', name: 'cotcom-list', component: DocList, props: { tipodocumento: 'COTP' }, meta: { requiresAuth: true, title: 'Cotizaciones de Proveedor', module: 'compras', permission: 'read' } },
  { path: '/compras/cotcom/nuevo', name: 'cotcom-nuevo', component: DocForm, props: { tipodocumento: 'COTP', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Cot. Proveedor', module: 'compras', permission: 'create' } },
  { path: '/compras/cotcom/:id(\\d+)/:token?', name: 'cotcom-ver', component: DocForm, props: r => ({ tipodocumento: 'COTP', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Cot. Proveedor', module: 'compras', permission: 'read' } },
  { path: '/compras/cotcom/:id(\\d+)/:token?/editar', name: 'cotcom-editar', component: DocForm, props: r => ({ tipodocumento: 'COTP', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Cot. Proveedor', module: 'compras', permission: 'update' } },
  { path: '/compras/cotcom/:pathMatch(.*)*', redirect: { name: 'cotcom-list' } },

  // Factura de Proveedor (FACP)
  { path: '/compras/facp', name: 'fac-list', component: DocList, props: { tipodocumento: 'FACP' }, meta: { requiresAuth: true, title: 'FACP', module: 'compras', permission: 'read' } },
  { path: '/compras/facp/nuevo', name: 'fac-nuevo', component: DocForm, props: { tipodocumento: 'FACP', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva FACP', module: 'compras', permission: 'create' } },
  { path: '/compras/facp/:id(\\d+)/:token?', name: 'fac-ver', component: DocForm, props: r => ({ tipodocumento: 'FACP', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver FACP', module: 'compras', permission: 'read' } },
  { path: '/compras/facp/:id(\\d+)/:token?/editar', name: 'fac-editar', component: DocForm, props: r => ({ tipodocumento: 'FACP', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar FACP', module: 'compras', permission: 'update' } },
  { path: '/compras/fac', redirect: { name: 'fac-list' } },
  { path: '/compras/fac/nuevo', redirect: { name: 'fac-nuevo' } },
  { path: '/compras/fac/:id(\\d+)/:token?', redirect: to => ({ name: 'fac-ver', params: to.params }) },
  { path: '/compras/fac/:id(\\d+)/:token?/editar', redirect: to => ({ name: 'fac-editar', params: to.params }) },
  { path: '/compras/fcpr', redirect: { name: 'fac-list' } },
  { path: '/compras/fcpr/nuevo', redirect: { name: 'fac-nuevo' } },
  { path: '/compras/fcpr/:id(\\d+)/:token?', redirect: to => ({ name: 'fac-ver', params: to.params }) },
  { path: '/compras/fcpr/:id(\\d+)/:token?/editar', redirect: to => ({ name: 'fac-editar', params: to.params }) },
  { path: '/compras/facp/:pathMatch(.*)*', redirect: { name: 'fac-list' } },
  { path: '/compras/fac/:pathMatch(.*)*', redirect: { name: 'fac-list' } },

  // Devoluciones de Compra
  { path: '/compras/deve', name: 'devecom-list', component: DocList, props: { tipodocumento: 'DEVP' }, meta: { requiresAuth: true, title: 'Devoluciones de Compra', module: 'compras', permission: 'read' } },
  { path: '/compras/deve/nuevo', name: 'devecom-nuevo', component: DocForm, props: { tipodocumento: 'DEVP', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Devolución de Compra', module: 'compras', permission: 'create' } },
  { path: '/compras/deve/:id(\\d+)/:token?', name: 'devecom-ver', component: DocForm, props: r => ({ tipodocumento: 'DEVP', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Devolución de Compra', module: 'compras', permission: 'read' } },
  { path: '/compras/deve/:id(\\d+)/:token?/editar', name: 'devecom-editar', component: DocForm, props: r => ({ tipodocumento: 'DEVP', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Devolución de Compra', module: 'compras', permission: 'update' } },
  { path: '/compras/deve/:pathMatch(.*)*', redirect: { name: 'devecom-list' } },

  // ==================================================
  // Módulo de Documentos Comerciales - Ventas
  // ==================================================

  // COTV — Cotización de Venta
  { path: '/ventas/cot', name: 'cotv-list', component: DocList, props: { tipodocumento: 'COTV' }, meta: { requiresAuth: true, title: 'COTV', module: 'ventas', permission: 'read' } },
  { path: '/ventas/cot/nuevo', name: 'cotv-nuevo', component: DocForm, props: { tipodocumento: 'COTV', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Cotización de Venta', module: 'ventas', permission: 'create' } },
  { path: '/ventas/cot/nueva', name: 'cotv-nueva', component: DocForm, props: { tipodocumento: 'COTV', modo: 'nueva' }, meta: { requiresAuth: true, title: 'Nueva Cotización de Venta', module: 'ventas', permission: 'create' } },
  { path: '/ventas/cot/:id(\\d+)/:token?', name: 'cotv-ver', component: DocForm, props: r => ({ tipodocumento: 'COTV', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Cotización de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/cot/:id(\\d+)/:token?/editar', name: 'cotv-editar', component: DocForm, props: r => ({ tipodocumento: 'COTV', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Cotización de Venta', module: 'ventas', permission: 'update' } },
  { path: '/ventas/cot/nueva/:id(\\d+)/:token?', name: 'cotv-nueva-ver', component: DocForm, props: r => ({ tipodocumento: 'COTV', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Cotización de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/cot/nueva/:id(\\d+)/:token?/editar', name: 'cotv-nueva-editar', component: DocForm, props: r => ({ tipodocumento: 'COTV', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Cotización de Venta', module: 'ventas', permission: 'update' } },
  { path: '/ventas/cot/:pathMatch(.*)*', redirect: { name: 'cotv-list' } },

  // Órdenes de Venta
  { path: '/ventas/ove', name: 'ove-list', component: DocList, props: { tipodocumento: 'OV' }, meta: { requiresAuth: true, title: 'Órdenes de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/ove/nuevo', name: 'ove-nuevo', component: DocForm, props: { tipodocumento: 'OV', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Orden de Venta', module: 'ventas', permission: 'create' } },
  { path: '/ventas/ove/:id(\\d+)/:token?', name: 'ove-ver', component: DocForm, props: r => ({ tipodocumento: 'OV', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Orden de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/ove/:id(\\d+)/:token?/editar', name: 'ove-editar', component: DocForm, props: r => ({ tipodocumento: 'OV', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Orden de Venta', module: 'ventas', permission: 'update' } },
  { path: '/ventas/ove/:pathMatch(.*)*', redirect: { name: 'ove-list' } },

  // Entregas (Salida de Inventario Ventas)
  { path: '/ventas/entiven', name: 'entiven-list', component: DocList, props: { tipodocumento: 'REM' }, meta: { requiresAuth: true, title: 'Entregas', module: 'ventas', permission: 'read' } },
  { path: '/ventas/entiven/nuevo', name: 'entiven-nuevo', component: DocForm, props: { tipodocumento: 'REM', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Entrega', module: 'ventas', permission: 'create' } },
  { path: '/ventas/entiven/:id(\\d+)/:token?', name: 'entiven-ver', component: DocForm, props: r => ({ tipodocumento: 'REM', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Entrega', module: 'ventas', permission: 'read' } },
  { path: '/ventas/entiven/:id(\\d+)/:token?/editar', name: 'entiven-editar', component: DocForm, props: r => ({ tipodocumento: 'REM', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Entrega', module: 'ventas', permission: 'update' } },
  { path: '/ventas/entiven/:pathMatch(.*)*', redirect: { name: 'entiven-list' } },

  // Facturas de Venta
  { path: '/ventas/fcve', name: 'fcve-list', component: DocList, props: { tipodocumento: 'FACV' }, meta: { requiresAuth: true, title: 'Facturas de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/fcve/nuevo', name: 'fcve-nuevo', component: DocForm, props: { tipodocumento: 'FACV', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Factura de Venta', module: 'ventas', permission: 'create' } },
  { path: '/ventas/fcve/nueva', name: 'fcve-nueva', component: DocForm, props: { tipodocumento: 'FACV', modo: 'nueva' }, meta: { requiresAuth: true, title: 'Nueva Factura de Venta', module: 'ventas', permission: 'create' } },
  { path: '/ventas/fcve/:id(\\d+)/:token?', name: 'fcve-ver', component: DocForm, props: r => ({ tipodocumento: 'FACV', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Factura de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/fcve/:id(\\d+)/:token?/editar', name: 'fcve-editar', component: DocForm, props: r => ({ tipodocumento: 'FACV', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Factura de Venta', module: 'ventas', permission: 'update' } },
  { path: '/ventas/fcve/nueva/:id(\\d+)/:token?', name: 'fcve-nueva-ver', component: DocForm, props: r => ({ tipodocumento: 'FACV', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Factura de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/fcve/nueva/:id(\\d+)/:token?/editar', name: 'fcve-nueva-editar', component: DocForm, props: r => ({ tipodocumento: 'FACV', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Factura de Venta', module: 'ventas', permission: 'update' } },
  { path: '/ventas/fcve/:pathMatch(.*)*', redirect: { name: 'fcve-list' } },

  // Devoluciones de Venta
  { path: '/ventas/deve', name: 'deveven-list', component: DocList, props: { tipodocumento: 'DEVV' }, meta: { requiresAuth: true, title: 'Devoluciones de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/deve/nuevo', name: 'deveven-nuevo', component: DocForm, props: { tipodocumento: 'DEVV', modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nueva Devolución de Venta', module: 'ventas', permission: 'create' } },
  { path: '/ventas/deve/:id(\\d+)/:token?', name: 'deveven-ver', component: DocForm, props: r => ({ tipodocumento: 'DEVV', modo: 'ver', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Devolución de Venta', module: 'ventas', permission: 'read' } },
  { path: '/ventas/deve/:id(\\d+)/:token?/editar', name: 'deveven-editar', component: DocForm, props: r => ({ tipodocumento: 'DEVV', modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Devolución de Venta', module: 'ventas', permission: 'update' } },
  { path: '/ventas/deve/:pathMatch(.*)*', redirect: { name: 'deveven-list' } },

  // ==================================================
  // Módulo de Tesorería / Pagos / Cartera (PLAN-003)
  // ==================================================
  { path: '/tesoreria/pagos',                             name: 'pago-list',  component: () => import('../modules/tesoreria/pago/views/PagoList.vue'),                meta: { requiresAuth: true, title: 'Pagos',          module: 'tesoreria' } },
  { path: '/tesoreria/pagos/nuevo',                       name: 'pago-nuevo', component: () => import('../modules/tesoreria/pago/views/PagoForm.vue'), props: { modo: 'nuevo' }, meta: { requiresAuth: true, title: 'Nuevo pago',  module: 'tesoreria' } },
  { path: '/tesoreria/pagos/:id(\\d+)',                   name: 'pago-ver',   component: () => import('../modules/tesoreria/pago/views/PagoForm.vue'), props: r => ({ modo: 'ver',    id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver pago',    module: 'tesoreria' } },
  { path: '/tesoreria/pagos/:id(\\d+)/editar',            name: 'pago-editar',component: () => import('../modules/tesoreria/pago/views/PagoForm.vue'), props: r => ({ modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar pago', module: 'tesoreria' } },

  { path: '/tesoreria/cuentas-bancarias',                 name: 'cuenta-bancaria-list', component: () => import('../modules/tesoreria/cuenta-bancaria/views/CuentaBancariaList.vue'), meta: { requiresAuth: true, title: 'Cuentas bancarias', module: 'tesoreria' } },

  { path: '/tesoreria/cartera',                           name: 'cartera-list', component: () => import('../modules/tesoreria/cartera/views/CarteraList.vue'), meta: { requiresAuth: true, title: 'Cartera', module: 'tesoreria' } },

  // Bancos (PLAN-010): importación de estados de cuenta + bitácora de movimientos
  { path: '/tesoreria/bancos/importar',                   name: 'banco-importar',    component: () => import('../modules/tesoreria/bancos/views/BancoImportView.vue'),      meta: { requiresAuth: true, title: 'Importar estado de cuenta', module: 'tesoreria' } },
  { path: '/tesoreria/bancos/movimientos',                name: 'banco-movimientos', component: () => import('../modules/tesoreria/bancos/views/BancoMovimientosView.vue'), meta: { requiresAuth: true, title: 'Movimientos bancarios',     module: 'tesoreria' } },
  { path: '/tesoreria/bancos/conciliacion',               name: 'banco-conciliacion', component: () => import('../modules/tesoreria/bancos/views/BancoConciliacionView.vue'), meta: { requiresAuth: true, title: 'Conciliación bancaria',      module: 'tesoreria' } },
  { path: '/tesoreria/bancos/reglas',                     name: 'banco-reglas',      component: () => import('../modules/tesoreria/bancos/views/BancoReglaView.vue'),       meta: { requiresAuth: true, title: 'Reglas de clasificación',   module: 'tesoreria' } },
  { path: '/tesoreria/bancos/configuracion',              name: 'banco-config',      component: () => import('../modules/tesoreria/bancos/views/BancoConfigView.vue'),      meta: { requiresAuth: true, title: 'Configuración bancaria',    module: 'tesoreria' } },

  // ==================================================
  // Modulo de Gestion de proyectos
  // ==================================================
  { path: '/proyectos', name: 'proyecto-gestion-list', component: ProyectoGestionList, meta: { requiresAuth: true, title: 'Gestion de proyectos', module: 'proyectos' } },
  { path: '/proyectos/:pathMatch(.*)*', redirect: { name: 'proyecto-gestion-list' } },

  // ==================================================
  // Módulo de Configuración de Compras (ex Usuarios)
  // ==================================================
  {
    path: '/compras/configuracion/usuarios',
    name: 'usuario-list',
    component: UsuarioList,
    meta: {
      requiresAuth: true,
      title: 'Usuarios de Compra',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Usuarios', path: '/compras/listausuarios' }
      ]
    }
  },
  {
    path: '/compras/usuarios/nuevo',
    name: 'usuario-nuevo',
    component: UsuarioForm,
    meta: {
      requiresAuth: true,
      title: 'Nuevo Usuario',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Usuarios', path: '/compras/listausuarios' },
        { name: 'Nuevo', path: '/compras/usuarios/nuevo' }
      ]
    }
  },
  {
    path: '/compras/usuarios/editar/:id',
    name: 'usuario-editar',
    component: UsuarioForm,
    props: (route) => ({
      id: route.params.id,
      modoEdicion: true
    }),
    meta: {
      requiresAuth: true,
      title: 'Editar Usuario',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Usuarios', path: '/compras/listausuarios' },
        { name: 'Editar', path: '/compras/usuarios/editar' }
      ]
    }
  },
  // Redirección para rutas no válidas de usuarios
  {
    path: '/compras/usuarios/:pathMatch(.*)*',
    redirect: { name: 'usuario-list' }
  },
  // ==================================================
  // Módulo de Reporte General
  // ==================================================
  {
    path: '/compras/reportegeneral',
    name: 'reporte-general-list',
    component: ReporteGeneralList,
    meta: {
      requiresAuth: true,
      title: 'Reporte General',
      breadcrumb: [
        { name: 'Compras', path: '/compras' },
        { name: 'Reporte General', path: '/compras/reportegeneral' }
      ]
    }
  },
  // Redirección para rutas no válidas de reporte general
  {
    path: '/compras/reportegeneral/:pathMatch(.*)*',
    redirect: { name: 'reporte-general-list' }
  },
  // ==================================================
  // Módulo de Trazabilidad de Compras — ERP externo (vía middleware)
  // ==================================================
  {
    path: '/reportes/compras/erp-trazabilidad',
    name: 'erp-trazabilidad-compras-list',
    component: ErpTrazabilidadComprasList,
    meta: {
      requiresAuth: true,
      title: 'Trazabilidad de compras (ERP)',
      breadcrumb: [
        { name: 'Reportes de compras', path: '/reportes/compras' },
        { name: 'Trazabilidad de compras (ERP)', path: '/reportes/compras/erp-trazabilidad' }
      ]
    }
  },
  {
    path: '/reportes/compras/seguimiento-firmes',
    name: 'seguimiento-firmes-soc-list',
    component: SeguimientoFirmesList,
    meta: {
      requiresAuth: true,
      title: 'Informe status de autorización',
      breadcrumb: [
        { name: 'Reportes de compras', path: '/reportes/compras' },
        { name: 'Informe status de autorización', path: '/reportes/compras/seguimiento-firmes' }
      ]
    }
  },
  // ==================================================
  // Módulo de Autorización (ex Matriz de Autorización)
  // ==================================================
  {
    path: '/compras/autorizacion',
    name: 'autorizacion',
    component: AutorizacionForm,
    meta: {
      requiresAuth: true,
      title: 'Matriz de Autorización',
      breadcrumb: [
        { text: 'Compras', active: false },
        { text: 'Matriz de Autorización', active: true }
      ]
    }
  },
  // ==================================================
  // Módulo de Listas de Precios
  // ==================================================
  {
    path: '/compras/listaprecios',
    name: 'lista-precios',
    component: ListaPreciosView,
    meta: {
      requiresAuth: true,
      title: 'Listas de Precios',
      breadcrumb: 'Listas de Precios',
      module: 'listaprecios',
      permission: 'read'
    }
  },
  // ==================================================
  // Página de Debug - Temporal
  // ==================================================
  {
    path: '/debug-access',
    name: 'debug-access',
    component: DebugAccessView,
    meta: { requiresAuth: false }
  },
  {
    path: '/cfdi/importacion',
    name: 'cfdi-importacion',
    component: CfdiImportacionView,
    meta: { requiresAuth: true, title: 'Importacion CFDI', module: 'cfdi', permission: 'read' }
  },
  {
    path: '/cfdi/fiel-sat',
    name: 'sat-fiel',
    component: SatFielView,
    meta: { requiresAuth: true, title: 'Configurar FIEL SAT', module: 'cfdi', permission: 'read' }
  },
  {
    path: '/cfdi/descarga-sat',
    name: 'sat-descarga-masiva',
    component: SatDescargaMasivaView,
    meta: { requiresAuth: true, title: 'Descarga Masiva SAT', module: 'cfdi', permission: 'read' }
  },
  {
    path: '/asistencia/turnos',
    name: 'asistencia-turnos',
    component: AsistenciaView,
    props: { mode: 'turnos' },
    meta: { requiresAuth: true, title: 'Asignación de turnos', module: 'asistencia', permission: 'update' }
  },
  {
    path: '/asistencia/checadas',
    name: 'asistencia-checadas',
    component: AsistenciaView,
    props: { mode: 'checadas' },
    meta: { requiresAuth: true, title: 'Checadas', module: 'asistencia', permission: 'create' }
  },
  {
    path: '/asistencia/jornadas',
    name: 'asistencia-jornadas',
    component: AsistenciaView,
    props: { mode: 'jornadas' },
    meta: { requiresAuth: true, title: 'Jornadas', module: 'asistencia', permission: 'read' }
  },
  // ==================================================
  // Catálogos - MODO1 de nomenclatura
  // ==================================================
  {
    path: '/catalogos/almacenes',
    name: 'cat-almacen',
    component: CatAlmacenView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Almacenes',
      breadcrumb: 'Catálogos > Almacenes'
    }
  },
  {
    path: '/catalogos/moneda',
    name: 'cat-moneda',
    component: CatMonedaView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Monedas',
      breadcrumb: 'Catálogos > Monedas'
    }
  },
  {
    path: '/catalogos/cecos',
    name: 'cat-ceco',
    component: CatCecoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Centros de Costo',
      breadcrumb: 'Catálogos > Centros de Costo'
    }
  },
  {
    path: '/catalogos/departamento',
    name: 'cat-departamento',
    component: CatDepartamentoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Departamentos',
      breadcrumb: 'Catálogos > Departamentos'
    }
  },
  {
    path: '/catalogos/material',
    name: 'cat-material',
    component: CatMaterialView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Materiales',
      breadcrumb: 'Catálogos > Materiales'
    }
  },
  {
    path: '/catalogos/socionegocio',
    name: 'cat-socionegocio',
    component: CatSocioNegocioView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Socios de Negocio',
      breadcrumb: 'Catálogos > Socios de Negocio'
    }
  },
  {
    path: '/catalogos/empleado',
    name: 'cat-empleado',
    component: CatEmpleadoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Empleados',
      breadcrumb: 'Catálogos > Empleados'
    }
  },
  {
    path: '/catalogos/cuentas',
    name: 'cat-cuenta-contable',
    component: CatCuentaContableView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Cuentas Contables',
      breadcrumb: 'Catálogos > Cuentas Contables'
    }
  },
  {
    path: '/catalogos/dimensiones',
    name: 'cat-dimension',
    component: CatDimensionView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Dimensiones',
      breadcrumb: 'Catálogos > Dimensiones'
    }
  },
  {
    path: '/catalogos/erp',
    name: 'cat-erp',
    component: CatErpView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de ERPs',
      breadcrumb: 'Catálogos > ERPs'
    }
  },
  {
    path: '/catalogos/estado',
    name: 'cat-estado',
    component: CatEstadoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Estados',
      breadcrumb: 'Catálogos > Estados'
    }
  },
  {
    path: '/catalogos/grupomaterial',
    name: 'cat-grupo-material',
    component: CatGrupoMaterialView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Grupos de Materiales',
      breadcrumb: 'Catálogos > Grupos de Materiales'
    }
  },
  {
    path: '/catalogos/gruposocionegocio',
    name: 'cat-grupo-socio-negocio',
    component: CatGrupoSocioNegocioView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Grupos de Socio de Negocio',
      breadcrumb: 'Catálogos > Grupos de Socio de Negocio'
    }
  },
  {
    path: '/catalogos/diascredito',
    name: 'cat-dias-credito',
    component: CatDiasCreditoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Días de Crédito',
      breadcrumb: 'Catálogos > Días de Crédito'
    }
  },
  {
    path: '/catalogos/impuesto',
    name: 'cat-impuesto',
    component: CatImpuestoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Impuestos',
      breadcrumb: 'Catálogos > Impuestos'
    }
  },
  {
    path: '/catalogos/mapeoerp',
    name: 'cat-mapeo-erp',
    component: CatMapeoErpView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Mapeo ERP',
      breadcrumb: 'Catálogos > Mapeo ERP'
    }
  },
  {
    path: '/catalogos/materialalmacen',
    name: 'cat-material-almacen',
    component: CatMaterialAlmacenView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Material en Almacenes',
      breadcrumb: 'Catálogos > Material en Almacenes'
    }
  },
  {
    path: '/catalogos/objeto',
    name: 'cat-objeto',
    component: CatObjetoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Objetos',
      breadcrumb: 'Catálogos > Objetos'
    }
  },
  {
    path: '/catalogos/proyecto',
    name: 'cat-proyecto',
    component: CatProyectoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Proyectos',
      breadcrumb: 'Catálogos > Proyectos'
    }
  },
  {
    path: '/catalogos/serie',
    name: 'cat-serie',
    component: CatSerieView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Series',
      breadcrumb: 'Catálogos > Series'
    }
  },
  {
    path: '/catalogos/umedida',
    name: 'cat-umedida',
    component: CatUMedidaView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Unidades de Medida',
      breadcrumb: 'Catálogos > Unidades de Medida'
    }
  },
  {
    path: '/catalogos/grupoempleado',
    name: 'cat-grupo-empleado',
    component: CatGrupoEmpleadoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Grupos de Empleados',
      breadcrumb: 'Catálogos > Grupos de Empleados'
    }
  },
  {
    path: '/catalogos/motivos-rechazo',
    name: 'cat-motivos-rechazo',
    component: CatMotivosRechazoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Motivos de Rechazo',
      breadcrumb: 'Catálogos > Motivos de Rechazo'
    }
  },
  {
    path: '/catalogos/sucursales',
    name: 'cat-sucursal',
    component: CatSucursalView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Sucursales',
      breadcrumb: 'Catálogos > Sucursales'
    }
  },
  {
    path: '/catalogos/condiciones-pago',
    name: 'cat-condicion-pago',
    component: CatCondicionPagoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Condiciones de Pago',
      breadcrumb: 'Catálogos > Condiciones de Pago'
    }
  },
  {
    path: '/catalogos/retenciones',
    name: 'cat-retencion',
    component: CatRetencionView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Retenciones',
      breadcrumb: 'Catálogos > Retenciones'
    }
  },
  {
    path: '/catalogos/paises',
    name: 'cat-pais',
    component: CatPaisView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Países',
      breadcrumb: 'Catálogos > Países'
    }
  },
  {
    path: '/catalogos/proyecto-estatus',
    name: 'cat-proyecto-estatus',
    component: CatProyectoEstatusView,
    meta: {
      requiresAuth: true,
      title: 'Estatus de proyecto',
      breadcrumb: 'Catálogos > Estatus de proyecto'
    }
  },
  {
    path: '/catalogos/proyecto-contacto-roles',
    name: 'cat-proyecto-contacto-roles',
    component: CatProyectoContactoRolView,
    meta: {
      requiresAuth: true,
      title: 'Roles de contacto en proyecto',
      breadcrumb: 'Catálogos > Roles de contacto en proyecto'
    }
  },
  {
    path: '/catalogos/proyecto-archivo-tipos',
    name: 'cat-proyecto-archivo-tipos',
    component: CatProyectoArchivoTipoView,
    meta: {
      requiresAuth: true,
      title: 'Tipos de archivo de proyecto',
      breadcrumb: 'Catálogos > Tipos de archivo de proyecto'
    }
  },
  {
    path: '/catalogos/empleado-archivo-tipos',
    name: 'cat-empleado-archivo-tipos',
    component: CatEmpleadoArchivoTipoView,
    meta: {
      requiresAuth: true,
      title: 'Tipos de expediente de empleado',
      breadcrumb: 'Catálogos > Tipos de expediente de empleado'
    }
  },
  {
    path: '/catalogos/bancos',
    name: 'cat-bancos',
    component: CatBancoView,
    meta: {
      requiresAuth: true,
      title: 'Bancos',
      breadcrumb: 'Catálogos > Bancos'
    }
  },
  {
    path: '/catalogos/empleado-identificacion-tipos',
    name: 'cat-empleado-identificacion-tipos',
    component: CatEmpleadoIdentificacionTipoView,
    meta: {
      requiresAuth: true,
      title: 'Tipos de identificación de empleado',
      breadcrumb: 'Catálogos > Tipos de identificación de empleado'
    }
  },
  {
    path: '/catalogos/turnos',
    name: 'cat-turnos',
    component: CatTurnoView,
    meta: {
      requiresAuth: true,
      title: 'Turnos',
      breadcrumb: 'Catálogos > Turnos'
    }
  },
  {
    path: '/catalogos/puestos',
    name: 'cat-puestos',
    component: CatPuestoView,
    meta: {
      requiresAuth: true,
      title: 'Puestos',
      breadcrumb: 'Catálogos > Puestos'
    }
  },
  {
    path: '/catalogos/personas-contacto',
    name: 'cat-persona-contacto',
    component: CatPersonaContactoView,
    meta: {
      requiresAuth: true,
      title: 'Personas contacto',
      breadcrumb: 'Catálogos > Personas contacto'
    }
  },
  {
    path: '/catalogos/sat',
    name: 'cat-sat',
    component: SatCatalogosView,
    meta: {
      requiresAuth: true,
      title: 'Catálogos SAT',
      breadcrumb: 'Catálogos > SAT'
    }
  },
  {
    path: '/catalogos/sat/formas-pago',
    name: 'cat-sat-formas-pago',
    component: SatFormaPagoView,
    meta: {
      requiresAuth: true,
      title: 'Formas de pago SAT',
      breadcrumb: 'Catálogos > SAT > Formas de pago'
    }
  },
  {
    path: '/catalogos/sat/metodos-pago',
    name: 'cat-sat-metodos-pago',
    component: SatMetodoPagoView,
    meta: {
      requiresAuth: true,
      title: 'Métodos de pago SAT',
      breadcrumb: 'Catálogos > SAT > Métodos de pago'
    }
  },
  {
    path: '/catalogos/sat/:catalogo',
    name: 'cat-sat-generico',
    component: SatCatalogoGenericoView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo SAT',
      breadcrumb: 'Catálogos > SAT'
    }
  },
  {
    path: '/config/empresas',
    name: 'cat-empresa',
    component: CatEmpresaView,
    meta: {
      requiresAuth: true,
      title: 'Catálogo de Empresas',
      breadcrumb: 'Config > Empresas'
    }
  },
  {
    path: '/config/usuarios',
    name: 'config-usuarios',
    component: () => import('../modules/usuarios/UsuarioList.vue'),
    meta: {
      requiresAuth: true,
      title: 'Usuarios',
      breadcrumb: 'Config > Usuarios'
    }
  },
  {
    path: '/config/usuariosx',
    name: 'config-usuariosx',
    component: () => import('../modules/usuarios/UsuariosX.vue'),
    meta: {
      requiresAuth: true,
      title: 'Usuarios X',
      breadcrumb: 'Config > Usuarios X'
    }
  },
  {
    path: '/config/usuarios-grupos',
    name: 'config-usuarios-grupos',
    component: () => import('../modules/grupos/UsuariosGruposEmpresa.vue'),
    meta: {
      requiresAuth: true,
      title: 'Usuarios por grupo',
      breadcrumb: 'Config > Usuarios por grupo'
    }
  },
  {
    path: '/config/autorizacion',
    name: 'autorizacion-regla-list',
    component: () => import('../modules/config/autorizacion/views/AutorizacionReglaList.vue'),
    meta: { requiresAuth: true, title: 'Matriz de autorizaciones', breadcrumb: 'Config > Matriz de autorizaciones' }
  },
  {
    path: '/config/autorizacion/nueva',
    name: 'autorizacion-regla-nueva',
    component: () => import('../modules/config/autorizacion/views/AutorizacionReglaForm.vue'),
    props: { id: 0 },
    meta: { requiresAuth: true, title: 'Nueva regla', breadcrumb: 'Config > Matriz > Nueva' }
  },
  {
    path: '/config/autorizacion/excel',
    name: 'autorizacion-excel',
    component: () => import('../modules/config/autorizacion/views/AutorizacionExcelForm.vue'),
    meta: { requiresAuth: true, title: 'Carga masiva', breadcrumb: 'Config > Matriz > Excel' }
  },
  {
    path: '/config/autorizacion/:id',
    name: 'autorizacion-regla-form',
    component: () => import('../modules/config/autorizacion/views/AutorizacionReglaForm.vue'),
    props: route => ({ id: Number(route.params.id) }),
    meta: { requiresAuth: true, title: 'Editar regla', breadcrumb: 'Config > Matriz > Editar' }
  },
  {
    path: '/config/doc-form-config',
    name: 'doc-form-config',
    component: () => import('../modules/config/docFormConfig/views/DocFormConfigList.vue'),
    meta: { requiresAuth: true, title: 'Config. campos de formulario', breadcrumb: 'Config > Campos de formulario' }
  },
  {
    path: '/config/req-area-usuarios',
    name: 'req-area-usuarios',
    component: () => import('../modules/config/reqAreaUsuario/views/ReqAreaUsuarioList.vue'),
    meta: {
      requiresAuth: true,
      title: 'REQ por ARTICULOS AREA',
      breadcrumb: 'Config > REQ por ARTICULOS AREA'
    }
  },
  {
    path: '/config/doc-empresa-config',
    name: 'doc-empresa-config',
    component: () => import('../modules/config/docEmpresaConfig/views/DocEmpresaConfigList.vue'),
    meta: { requiresAuth: true, title: 'Config. flujo documentos', breadcrumb: 'Config > Flujo documentos' }
  },
  {
    path: '/config/admin-sapbo',
    name: 'admin-sapbo',
    component: () => import('../modules/config/adminSapBo/views/AdminSapBoView.vue'),
    meta: { requiresAuth: true, title: 'Administrar SAP B1', breadcrumb: 'Config > Administrar SAP B1' }
  },
  {
    path: '/config/acceso',
    name: 'config-acceso',
    component: () => import('../modules/config/acceso/AccesoList.vue'),
    meta: { requiresAuth: true, title: 'Accesos al sistema', breadcrumb: 'Config > Accesos al sistema' }
  },

  // ==================================================
  // Finanzas — Presupuesto
  // ==================================================
  { path: '/finanzas/presupuestos',          name: 'presupuesto-list',  component: PresupuestoList, meta: { requiresAuth: true, title: 'Presupuestos' } },
  { path: '/finanzas/presupuestos/nuevo',    name: 'presupuesto-nuevo', component: PresupuestoForm, props: { modo: 'nuevo', id: 0 }, meta: { requiresAuth: true, title: 'Nuevo Presupuesto' } },
  { path: '/finanzas/presupuestos/:id(\\d+)',        name: 'presupuesto-ver',   component: PresupuestoForm, props: r => ({ modo: 'ver',    id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Ver Presupuesto' } },
  { path: '/finanzas/presupuestos/:id(\\d+)/editar', name: 'presupuesto-editar',component: PresupuestoForm, props: r => ({ modo: 'editar', id: Number(r.params.id) }), meta: { requiresAuth: true, title: 'Editar Presupuesto' } },
  { path: '/finanzas/presupuestos/:pathMatch(.*)*', redirect: { name: 'presupuesto-list' } },

  // Dirección que no existe: al inicio (si no hay sesión, el inicio manda al login) en vez de quedar en blanco
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Protección de rutas
import authService from '../services/auth'

// Función para verificar si una ruta está permitida para el usuario actual
const isRouteAllowed = (routePath) => {
  // Si la ruta es login, siempre está permitida
  if (routePath === '/login' || routePath === '/recuperar-password' || routePath === '/recuperar-password/nueva') {
    return true;
  }

  // Si el usuario está autenticado y va al dashboard, a su perfil o a sus pendientes, permitir siempre.
  if (routePath === '/' || routePath === '/perfil' || routePath === '/pendientes') {
    return true;
  }

  // Dashboard administrativo: accesible aunque no esté en MenuList/ModuloList
  if (routePath === '/_admin') {
    return true;
  }

  // Permitir acceso a rutas de negocio y catálogos
  if (routePath === '/test' || routePath === '/debug-access' ||
    routePath.startsWith('/catalogos/') || routePath.startsWith('/compras/') ||
    routePath.startsWith('/ventas/') || routePath.startsWith('/config/') ||
    routePath.startsWith('/cfdi/') ||
    routePath.startsWith('/proyectos') || routePath.startsWith('/asistencia/')) {
    return true;
  }

  // Obtener el usuario y sus menús/módulos
  const userData = authService.getUserData();
  if (!userData || !userData._UsuarioMo) {
    return false;
  }

  // Normalizar la ruta (quitar el primer slash si existe)
  const normalizedPath = routePath.startsWith('/') ? routePath.substring(1) : routePath;

  // Verificar si la ruta está en _MenuList.Enlace
  if (userData._UsuarioMo && userData._UsuarioMo._MenuList && Array.isArray(userData._UsuarioMo._MenuList)) {
    const menuMatch = userData._UsuarioMo._MenuList.some(menu => {
      // Normalizar el enlace del menú (puede o no tener slash inicial)
      const menuPath = menu.Enlace && menu.Enlace.startsWith('/') ? menu.Enlace.substring(1) : menu.Enlace || '';
      return menuPath === normalizedPath || normalizedPath.startsWith(menuPath + '/');
    });

    if (menuMatch) {
      return true;
    }
  }

  // Verificar si la ruta está en _ModuloList.Ruta
  if (userData._UsuarioMo && userData._UsuarioMo._ModuloList && Array.isArray(userData._UsuarioMo._ModuloList)) {
    const moduleMatch = userData._UsuarioMo._ModuloList.some(modulo => {
      // Normalizar la ruta del módulo (puede o no tener slash inicial)
      const modulePath = modulo.Ruta && modulo.Ruta.startsWith('/') ? modulo.Ruta.substring(1) : modulo.Ruta || '';
      return modulePath === normalizedPath || normalizedPath.startsWith(modulePath + '/');
    });

    if (moduleMatch) {
      return true;
    }
  }

  // Si llegamos aquí, la ruta no está permitida
  return false;
};

router.beforeEach((to, from, next) => {
  // Verificar si la ruta requiere autenticación
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verificar si el usuario está autenticado
    if (!authService.isAuthenticated()) {
      // Redirigir a la página de login; al entrar regresa a donde iba (ej. enlace de un correo)
      next({ name: 'login', query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {} });
      return;
    }

    // Verificar si la ruta está permitida para el usuario
    if (isRouteAllowed(to.path)) {
      // Usuario autenticado y ruta permitida
      next();
    } else {
      // Ruta no permitida, redirigir al dashboard
      console.warn(`Acceso denegado a la ruta: ${to.path}. No está en MenuList.Enlace ni en ModuloList.Ruta`);
      next({ name: 'dashboard' });
    }
  } else {
    // Ruta pública, permitir acceso
    next();
  }
})

export default router

